import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../components/usePasswordAuth";
import './Password.css';

const Password = () => {
	const [password, setPassword] = useState("");
  const [error, setError] = useState('');
	const navigate = useNavigate();
	const location = useLocation();
	const { login } = useAuth();

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (login(password)) {
			const params = new URLSearchParams(location.search);
			const redirectTo = params.get("redirect") || "/";
			console.log("navigate", redirectTo);
			navigate(redirectTo, { replace: true });
		} else {
      setError('Not quite... Hint: Flip the tape to Side B 🎶');
    }
	};

	return (
		<div className="password-page">
			<div className="password-box">
				<form onSubmit={handleSubmit}>
					<input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
					{error && <p className="hint">{error}</p>}
					<button type="submit">Let me in</button>
				</form>
			</div>
		</div>
	);
};

export default Password;
